<template>
  <v-menu v-if="hasMultipleAvailableLocales" offset-y left>
    <v-btn slot="activator"
           :title="$t('message.menu.locale')"
           icon>
      <v-icon>language</v-icon>
    </v-btn>

    <v-list>
      <v-list-tile
        v-for="({ code, name, flag }, index) in availableLocales" :key="name"
        :class="{
          active: currentLocale === code,
          'mb-1': index !== availableLocales.length - 1,
        }"
        @click="setLocale(code)">
        <v-flex class="d-flex mr-3" v-html="flag"></v-flex>
        <v-list-tile-content>
          <v-list-tile-title>{{ name }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { i18n } from '@/plugins/vue-i18n';
import locales from '@/locale';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'nx-locale-selector-menu',
  computed: {
    ...mapState({
      currentLocale: state => state.locale.current,
    }),
    ...mapGetters(['availableLocales']),
    hasMultipleAvailableLocales() {
      return this.availableLocales.length > 1;
    },
  },
  methods: {
    ...mapActions({
      setLocale: 'SET_LOCALE',
    }),
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variables.styl'

.active {
  background-color: $nx-primary--lighten-4;
}
</style>
